import { Range } from '../../types'

interface HomeDateRangePickerProps {
  value: Range
  onChange: (range: Range) => void
}

const HomeDateRangePicker = ({ value, onChange }: HomeDateRangePickerProps) => {
  const formatDateForInput = (date: Date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStart = new Date(e.target.value)
    if (newStart <= value.end) {
      onChange({ start: newStart, end: value.end })
    }
  }

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEnd = new Date(e.target.value)
    // Set to end of day
    newEnd.setHours(23, 59, 59, 999)
    if (newEnd >= value.start) {
      onChange({ start: value.start, end: newEnd })
    }
  }

  return (
    <div className="flex items-center space-x-3">
      <span className="text-gray-500 dark:text-gray-400">From:</span>
      
      <div className="flex items-center space-x-2">
        <input
          type="date"
          value={formatDateForInput(value.start)}
          onChange={handleStartDateChange}
          max={formatDateForInput(value.end)}
          className="px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
        
        <span className="text-gray-500 dark:text-gray-400">To:</span>
        
        <input
          type="date"
          value={formatDateForInput(value.end)}
          onChange={handleEndDateChange}
          min={formatDateForInput(value.start)}
          className="px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
      </div>
    </div>
  )
}

export default HomeDateRangePicker
